import React from "react";
import { Link, useParams } from "react-router-dom";

import CGMStatusCardTemplate from "./CGMStatusCardTemplate";
import TimerDisplay from "src/components/app/TimerDisplay";
import CGMConnectedStatus from "src/assets/images/cgm/status/cgm-connected-status.png";

import { CgmDisplayStatus } from "src/constants/cgm";
import useCgmHook from "src/hooks/useCgm.hook";

interface CGMStatusCardDefaultProps {
  color: string;
  label: string;
  bgColor?: string;
  displayStatus: CgmDisplayStatus;
}

/** Same live-reading resolution as `CgmReadingCard` so status card matches insights. */
const CGMStatusCardDefault: React.FC<CGMStatusCardDefaultProps> = ({
  color,
  label,
  bgColor,
  displayStatus,
}) => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"] ?? "";
  const { glucoseValue, timestamp, sensorInfo } = useCgmHook();

  return (
    <CGMStatusCardTemplate
      image={CGMConnectedStatus}
      color={color}
      bgColor={bgColor}
      label={label}
      description={
        <div className="my-2">
          <p className="text-xs text-gray-500 mb-1">Glucose Reading</p>
          <div className="flex items-baseline gap-1 flex-wrap">
            <span className="text-xl font-bold text-gray-900">
              {glucoseValue ?? "---"} mg/dL
            </span>
            {timestamp && (
              <p className="text-xs text-gray-500">
                {glucoseValue != null ? "Live · " : "Synced at "}
                <TimerDisplay timestamp={timestamp} showLiveUpdate={true} />
              </p>
            )}
          </div>
        </div>
      }
      sensorStartDate={sensorInfo.startDate}
      sensorEndDate={sensorInfo.endDate}
      bottomContent={
        <p className="text-sm text-gray-500 text-center">
          Take a look at your{" "}
          <Link
            to={`/app/${supportProgramKey}/insights-screen?tab=vitals&sub-tab=glucose`}
            className="text-[var(--app-primary)] font-semibold underline"
          >
            CGM Insights
          </Link>
        </p>
      }
    />
  );
};

export default CGMStatusCardDefault;
